import types from './constants'

export default {
  [types.TRACKING_SELECT]: (selection) => ({
   type: types.TRACKING_SELECT,
   selection,
  }),
  [types.TRACKING_SORT]: (sort) => ({
   type: types.TRACKING_SORT,
   sort
  }),
  [types.TRACKING_PENDING]: () => ({
   type: types.TRACKING_PENDING,
  }),
  [types.TRACKING_COMPLETE]: (report, activities) => ({
   type: types.TRACKING_COMPLETE,
   report,
   activities,
  }),
  [types.TRACKING_ERROR]: (error) => ({
   type: types.TRACKING_ERROR,
   error
  })
}

export const setTrackingReport = data => ({
  type: types.TRACKING_COMPLETE,
  report: {data}
})